<style lang="scss" scoped>
.fullSortStyle{
    width: 100%;
    background-color:#fff;
	border-top:#eee solid 1px;
}
.sort-box,  .sort-box-invoice{
    height:40px;	
    display:flex;
	-webkit-box-align:center;
	-webkit-box-pack:justify;
	//padding:0 20px;
    width: 90%;
    margin:0 auto;	
    position: relative;
    z-index: 100
}


.sort-title  {
    display:-webkit-box;
	-webkit-box-align:center;
	font-size:11px;
	height:38px;
	line-height:38px;
	text-align:center;	
}
.sort-title div{
    min-width: 20px;
    min-height: 20px;
}

.sort-box .sort-choose {  
    width:40%;
	color:#16ba63;
}
.sort-box .sort-nochoose {  
   width:40%;
   color:#333;
}

.sort-box-invoice .sort-choose {  
    width:30%;
	color:#16ba63;
}
.sort-box-invoice .sort-nochoose {  
   width:30%;
   color:#333;
}

.sort-icon {
    display:block;
    margin:0px 3px 0px 3px;	
	width:18px!important;
	height:18px!important;
	transform:translateY(1px);
    z-index: 100
}
.sort-fliter,.sort-invoice {
    text-align:right;
	
	color:#333;
    z-index: 100
}
.sort-fliter {    
	width:20%;	
}
.sort-invoice {    
	width:20%;	
}
</style>
<template>
   <section>
       <div class="fullSortStyle">
          <div v-bind:class="containerClass">
                <div v-on:click="sortOrderTimeTap" v-bind:class="orderTxtClass">
                    <div><img class="sort-icon" v-bind:src="orderIconUrl"></div>
                    <div>预订(近-远)</div>                
                </div>
                <div v-on:click="sortTravelTimeTap" v-bind:class="travelTxtClass">
                    <div><img style="width:20px;height:20px;" class="sort-icon" v-bind:src="travelIconUrl"></div>
                    <div>出发(晚-早)</div>                
                </div>
                <div v-on:click="filterIndent" class="sort-title sort-fliter">                
                    <div>
                    <img style="width:20px;height:20px;" class="sort-icon" src="//file.40017.cn/tcservice/wxapp/xcx/order/sort/img190515/icon_default_shaixuan.png">
                    </div>
                    <div>筛选</div>
                </div>
                <div v-if="isShowInvoice" v-on:click="gotoInvoice" class="sort-title sort-invoice">                
                    <div>
                    <img style="width:20px;height:20px;" class="sort-icon" src="https://file.40017.cn/tcservice/wxapp/xcx/order/sort/img190515/icon_default_fapiao.png">
                    </div>
                    <div>开发票</div>
                </div>
           </div>
        </div>
   </section>
</template>

<script>
const chooseOrderIcon = "//file.40017.cn/tcservice/wxapp/xcx/order/sort/img190613/icon_selected_yuding.png"
const unchooseOrderIcon = "//file.40017.cn/tcservice/wxapp/xcx/order/sort/img190613/icon_default_yuding.png"
const chooseTravelIcon = "//file.40017.cn/tcservice/wxapp/xcx/order/sort/img190613/icon_selected_chuxing.png"
const unchooseTravelIcon = "//file.40017.cn/tcservice/wxapp/xcx/order/sort/img190613/icon_default_chuxing.png"
const chooseClass="sort-title sort-choose"
const unchooseClass="sort-title sort-nochoose"

//import Bus from './bus.js'
import {getCookie} from './../util/tool.js'
export default {    
    props:{
        viewInvoice:Boolean,
        viewInvoiceNum:Number,        
        invoiceUrl:String,
        initSortType:Number
    },
	data:function() {        
		return {
			sortType: "order",
            orderTxtClass: chooseClass,
            orderIconUrl: chooseOrderIcon,
            travelTxtClass: unchooseClass,
            travelIconUrl: unchooseTravelIcon,
            userInfo: {				//用户信息数据
				openId: '',
				unionid: '',
            },
            isViewInvoice:false,            
            containerClassArray:["sort-box","sort-box-invoice"]
		}
    },
    computed: {        
		containerClass: function() {            
            //返回是否应该展示空态页            
            if(this.viewInvoiceNum===undefined||this.viewInvoiceNum=="viewInvoiceNum"){
                this.viewInvoiceNum=0
            }            
            
            return this.containerClassArray[this.viewInvoiceNum]           
        },
        isShowInvoice: function() {      //返回是否应该展示空态页 
            if(this.viewInvoice===undefined){
                this.viewInvoice=false
            }
            return this.viewInvoice
		}
	},
	methods: {       
        sortOrderTimeTap: function () {            
            if(this.sortType=="order"){
                return
            }
            this.sortType="order"
            this.orderIconUrl=chooseOrderIcon
            this.orderTxtClass=chooseClass
            this.travelIconUrl=unchooseTravelIcon
            this.travelTxtClass=unchooseClass            
            this.$emit("sortOrderTime")
        },
        sortTravelTimeTap: function () {                        
            if(this.sortType=="travel"){
                return
            }
            this.sortType="travel"
            this.orderIconUrl=unchooseOrderIcon
            this.orderTxtClass=unchooseClass
            this.travelIconUrl=chooseTravelIcon
            this.travelTxtClass=chooseClass            
            this.$emit("sortTravelTime")
        },
        //点击晒选框跳转到订单筛选页面
        filterIndent() { 
            setTrackEvent(
                '微信钱包-订单',
                '分类订单',
                '点击分类订单',
                '^点击^openid:' + this.userInfo.openId + '^'
                );
            setTimeout(function(){                
                var domain=window.location.href.substring(0,window.location.href.indexOf("/"))
                window.location = domain + '/ordercenterfront/#/classifylist';
            }, 10);                
        },
         //点击晒选框跳转到订单筛选页面
        gotoInvoice() {   
            let that=this          
            setTimeout(function(){
                window.location=that.invoiceUrl
            }, 10);                
        },
        spliteWxUser:function(rStr,str){
            try{
                let a = rStr.split("&");
                for (let i in a)
                    if (a[i].indexOf(str + "=") >= 0) {
                        let n = a[i].split("=");
                        if (null != n[1])
                            return n[1]
                    }
                return ""
            }
            catch(e){
            }
            return ''
         },
    },    
    beforeMount() {		
         let wxuser = getCookie('WxUser');
         if(wxuser){
            this.userInfo.openId =this.spliteWxUser(wxuser, 'openid')
			this.userInfo.unionid =this.spliteWxUser(wxuser, 'unionid')
         }
         if(this.initSortType==3){
             this.sortType="travel";
             this.orderIconUrl=unchooseOrderIcon;
             this.orderTxtClass=unchooseClass;
             this.travelIconUrl=chooseTravelIcon;
             this.travelTxtClass=chooseClass;
         }else{
             this.sortType="order";
             this.orderIconUrl=chooseOrderIcon;
             this.orderTxtClass=chooseClass;
             this.travelIconUrl=unchooseTravelIcon;
             this.travelTxtClass=unchooseClass; 
         }         
    }     
}

function setTrackEvent(Category, Action, Label, Value) {    
  var i = 1;
  var t = window.setInterval(setEvent, 1000);
  setEvent();
  function setEvent() {
    i++ > 10 && window.clearInterval(t);
    if (window._tcTraObj && _tcTraObj._tcTrackEvent && _tcTraObj._tcTrackPage) {
      _tcTraObj._tcTrackEvent(Category, Action, Label, Value);
      window.clearInterval(t);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sort.vue